/**
 * SA Shop Subscription New: Monthly/Annual toggle.
 * Scope: queries only within section wrapper. No console.log.
 */
(function () {
  'use strict';

  var ROOT_TAG = 'sa-shop-subscription-new';
  var TOGGLE_SEL = '.js-sub-new-toggle';
  var TABLE_WRAP_SEL = '.sa-shop-sub-new__table-wrap';
  var FOOTER_SEL = '.sa-shop-sub-new__footer';
  var TOGGLE_ACTIVE_CLASS = 'sa-shop-sub-new__toggle-btn--active';
  var TABLE_VISIBLE_CLASS = 'sa-shop-sub-new__table-wrap--visible';
  var FOOTER_VISIBLE_CLASS = 'sa-shop-sub-new__footer--visible';

  function SaShopSubNew(rootEl) {
    this.root = rootEl;
    this.toggleBtns = rootEl ? Array.from(rootEl.querySelectorAll(TOGGLE_SEL)) : [];
    this.tableWraps = rootEl ? Array.from(rootEl.querySelectorAll(TABLE_WRAP_SEL)) : [];
    this.footers = rootEl ? Array.from(rootEl.querySelectorAll(FOOTER_SEL)) : [];
    this.handleToggleClick = this.handleToggleClick.bind(this);
  }

  SaShopSubNew.prototype.init = function () {
    if (!this.root || this.toggleBtns.length === 0) return;

    this.toggleBtns.forEach(function (btn) {
      btn.addEventListener('click', this.handleToggleClick);
    }, this);
  };

  SaShopSubNew.prototype.destroy = function () {
    this.toggleBtns.forEach(function (btn) {
      btn.removeEventListener('click', this.handleToggleClick);
    }, this);
  };

  SaShopSubNew.prototype.handleToggleClick = function (e) {
    var btn = e && e.currentTarget;
    if (!btn) return;
    var source = btn.getAttribute('data-sub-source');
    if (!source) return;
    this.switchTo(source);
  };

  SaShopSubNew.prototype.switchTo = function (source) {
    var i;

    for (i = 0; i < this.toggleBtns.length; i++) {
      var b = this.toggleBtns[i];
      var active = b.getAttribute('data-sub-source') === source;
      b.classList.toggle(TOGGLE_ACTIVE_CLASS, active);
      b.setAttribute('aria-selected', active ? 'true' : 'false');
    }

    for (i = 0; i < this.tableWraps.length; i++) {
      var wrap = this.tableWraps[i];
      var visible = wrap.getAttribute('data-sub-source') === source;
      wrap.classList.toggle(TABLE_VISIBLE_CLASS, visible);
      wrap.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (visible) {
        wrap.removeAttribute('style');
      }
    }

    for (i = 0; i < this.footers.length; i++) {
      var footer = this.footers[i];
      var showFooter = footer.getAttribute('data-sub-footer') === source;
      footer.classList.toggle(FOOTER_VISIBLE_CLASS, showFooter);
      footer.setAttribute('aria-hidden', showFooter ? 'false' : 'true');
    }
  };

  var instances = new WeakMap();

  function initRoot(root) {
    if (!root) return;

    var existing = instances.get(root);
    if (existing) {
      existing.destroy();
      instances.delete(root);
    }

    var inst = new SaShopSubNew(root);
    inst.init();
    instances.set(root, inst);
  }

  window.initSaShopSubNew = function (sectionId) {
    var root = document.getElementById('sa-shop-subscription-new-' + sectionId);
    initRoot(root);
  };

  if (!customElements.get(ROOT_TAG)) {
    customElements.define(ROOT_TAG, class SaShopSubscriptionNew extends HTMLElement {
      connectedCallback() {
        initRoot(this);
      }

      disconnectedCallback() {
        var existing = instances.get(this);
        if (existing) {
          existing.destroy();
          instances.delete(this);
        }
      }
    });
  }
})();
